import * as React from "react";
const SvgTicket = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.791 5.93a1.75 1.75 0 0 0-1.42 2.028l.521 2.954a.75.75 0 0 0 .87.609 2.25 2.25 0 0 1 .78 4.431.75.75 0 0 0-.608.87l.521 2.954a1.75 1.75 0 0 0 2.028 1.42l17.726-3.127a1.75 1.75 0 0 0 1.42-2.027l-.521-2.954a.75.75 0 0 0-.87-.609 2.25 2.25 0 1 1-.78-4.431.75.75 0 0 0 .608-.87l-.521-2.954a1.75 1.75 0 0 0-2.028-1.42L1.791 5.932Zm.058 1.767a.25.25 0 0 1 .202-.29l17.727-3.125a.25.25 0 0 1 .29.203l.403 2.29a3.751 3.751 0 0 0 1.277 7.238l.403 2.29a.25.25 0 0 1-.202.29L4.222 19.717a.25.25 0 0 1-.29-.203l-.403-2.29a3.751 3.751 0 0 0-1.277-7.238l-.403-2.29Zm10.026-.125a.75.75 0 0 0-1.271.225L9.816 9.89l-2.065.861a.75.75 0 0 0-.18 1.278l1.748 1.397.18 2.23a.75.75 0 0 0 1.16.565l1.869-1.23 2.176.517a.75.75 0 0 0 .897-.928l-.593-2.157 1.165-1.91a.75.75 0 0 0-.606-1.14l-2.235-.103-1.457-1.698Zm-.77 3.15.457-1.211.842.982a.75.75 0 0 0 .535.26l1.293.06-.673 1.106a.75.75 0 0 0-.083.589l.343 1.248-1.26-.3a.75.75 0 0 0-.586.104l-1.08.712-.105-1.29a.75.75 0 0 0-.28-.526l-1.01-.808 1.194-.498a.75.75 0 0 0 .413-.428Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgTicket;
